import { Link } from 'react-router-dom';
import PageShell, { PageTitle } from '../components/PageShell';
import CallButton from '../components/CallButton';
import HelpBox from '../components/HelpBox';

export default function NotFound() {
  return (
    <PageShell>
      <PageTitle
        title="We Couldn’t Find That Page"
        lead="The link may be old or the page may have moved. One of these should get you back on track."
      />
      <ul className="link-list">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/blogs">All help guides</Link></li>
        <li><Link to="/support">Support center</Link></li>
        <li><Link to="/faqs">FAQs</Link></li>
        <li><Link to="/contact-us">Contact us</Link></li>
      </ul>
      <CallButton />
      <HelpBox
        title="Tell Us What You Were Looking For"
        text="A technician can point you to the right guide, or simply answer your question directly."
      />
    </PageShell>
  );
}
